import { gql } from '@apollo/client';

export const UnblockUserMutationName = 'UnblockUser';

export const UNBLOCK_USER_MUTATION = gql`
  mutation ${UnblockUserMutationName}($userId: ID!) {
    unblockUser(userId: $userId)
  }
`;
